import React, { useRef } from 'react';
import gsap from 'gsap';
import { useGSAP } from '@gsap/react';
import './style/TiltCard.css';

const TiltCard = ({ title, desc, icon, link }) => {
    const cardRef = useRef(null);

    useGSAP(() => {
        const card = cardRef.current;

        const onMouseMove = (e) => {
            const rect = card.getBoundingClientRect();
            
            // 1. حساب عرض وارتفاع الكارت الحالي
            const width = rect.width;
            const height = rect.height;

            // 2. حساب مكان الماوس بالنسبة لمركز الكارت (نقطة المنتصف هي 0،0)
            const mouseX = e.clientX - rect.left - width / 2;
            const mouseY = e.clientY - rect.top - height / 2;

            // 3. تحويل الإحداثيات إلى درجات ميل (أقصى زاوية ميل هنا هي 25 درجة)
            // الحسبة الرياضية تضمن توجيه الكارت ليتطلع باتجاه مؤشر الماوس بدقة
            const rX = (mouseY / height) * 25; 
            const rY = -(mouseX / width) * 25; 

            // 4. تفعيل الأنميشن فوراً وبأعلى أداء عبر GSAP
            gsap.to(card, {
                rotateX: rX,
                rotateY: rY,
                duration: .1,
                ease: "power2.out",
                overwrite: "auto"
            });

            // 5. حساب النسبة المئوية للموس لتحديث الـ Glow الخلفي في الـ CSS
            const glowX = ((e.clientX - rect.left) / width) * 100;
            const glowY = ((e.clientY - rect.top) / height) * 100;
            card.style.setProperty('--mouse-x', `${glowX}%`);
            card.style.setProperty('--mouse-y', `${glowY}%`);
        };

        const onMouseLeave = () => {
            // إعادة الكارت للوضعية المسطحة الأصلية بنعومة بالغة عند خروج الماوس
            gsap.to(card, {
                rotateX: 0,
                rotateY: 0,
                duration: .5,
                ease: "bounce.out",
                overwrite: "auto"
            });
        };

        // ربط الأحداث بالكارت
        card.addEventListener('mousemove', onMouseMove);
        card.addEventListener('mouseleave', onMouseLeave);

        return () => {
            card.removeEventListener('mousemove', onMouseMove);
            card.removeEventListener('mouseleave', onMouseLeave);
        };
    }, []);

    return (
        <div ref={cardRef} className="tilt-card">
            {/* طبقة الإضاءة التفاعلية */}
            <div className="tilt-card-glow" />
            
            {/* الأيقونة العائمة */}
            <div className="tilt-element-box">
                <a href={link} target='_blank' rel='noreferrer'><i class={icon}></i></a>
            </div>
            
            {/* النصوص العائمة بارتفاعات مختلفة */}
            <div>
                <h3 className="tilt-element-title">{title}</h3>
                <p className="tilt-element-desc">{desc}</p>
            </div>
        </div>
    );
};

export default TiltCard;